import { Box, Flex, HStack, Text } from '@chakra-ui/react';

export interface Step {
  id: number;
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  current: number;
}

const StepIndicator = ({ steps, current }: StepIndicatorProps) => (
  <Flex flex={1} justify="center" align="center" gap="0" w="full">
    {steps.map((step, index) => {
      const isActive = step.id === current;
      const isDone = step.id < current;
      return (
        <HStack key={step.id} gap="0" align="center">
          {index > 0 && (
            <Box
              w="8"
              h="1px"
              bg={isActive || isDone ? 'argos.fg' : 'border'}
              mx="1"
              flexShrink="0"
              marginX={2}
            />
          )}
          <HStack gap="1.5" align="center">
            <Flex
              align="center"
              justify="center"
              boxSize="6"
              rounded="full"
              fontSize="xs"
              fontWeight="bold"
              flexShrink="0"
              bg={isActive || isDone ? 'argos.fg' : 'bg.muted'}
              color={isActive || isDone ? 'grayscale' : 'fg.muted'}
            >
              {step.id}
            </Flex>
            <Text
              fontSize="sm"
              fontWeight={isActive ? 'semibold' : 'normal'}
              color={isActive ? 'fg' : 'fg.muted'}
              whiteSpace="nowrap"
            >
              {step.label}
            </Text>
          </HStack>
        </HStack>
      );
    })}
  </Flex>
);

export default StepIndicator;
